
const YokohamaDataState = {
    selectedTree: null,
}

export default YokohamaDataState
